<div class="counter flex gap-5">
    <label>{{label}}</label>
    <span color="primary">{{value}}</span>
</div>